import { Button } from "@/components/ui/button" // Assuming Button path
import { User } from "@/api/users" // Assuming User type is exported

interface SuccessScreenProps {
  user?: User; // User object, optional for greeting
  onNext: () => void; // This will be the Go to Dashboard action from parent
}

export default function SuccessScreen({ user, onNext }: SuccessScreenProps) {
  return (
    <div className="text-center">
      <svg
        className="mx-auto h-16 w-16 text-green-500"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h2 className="mt-4 text-2xl font-semibold text-gray-900">
        Onboarding Complete!
      </h2>
      {user?.email && (
        <p className="mt-2 text-sm text-gray-600">
          Welcome aboard, <span className="font-medium">{user.email}</span>!
        </p>
      )}
      <p className="mt-2 text-sm text-gray-600">
        Your account is set up and you're ready to explore BraidPay.
      </p>
      {user?.kycStatus === "PENDING" && (
        <p className="mt-3 text-sm text-yellow-700 bg-yellow-50 p-3 rounded-md">
          Your Identity Verification is still pending review. We'll notify you
          once it's complete.
        </p>
      )}
      {user?.kycStatus !== "SUCCESS" && user?.kycStatus !== "PENDING" && (
        <p className="mt-3 text-sm text-orange-700 bg-orange-50 p-3 rounded-md">
          Remember to complete your Identity Verification to access all
          features.
        </p>
      )}
      <div className="mt-8">
        <Button
          onClick={onNext}
          data-testid="go-to-dashboard-button"
          className="w-full"
        >
          Go to Dashboard
        </Button>
        <Button
          onClick={() => window.open("http://youtube.com/@braidpay", "_blank")}
          variant="outline"
          className="w-full mt-4"
          data-testid="video-guides-button"
        >
          Watch Video Guides
        </Button>
      </div>
    </div>
  )
}
